// eslint-disable-next-line import/prefer-default-export
export const handleFormatApprovalRequest = (approvalRequest, currentUserID) => {
  const pendingIndex = approvalRequest.reviewLog.findIndex((level) => {
    return !level.approved_at && !level.denied_at;
  });
  return approvalRequest.approvers.flatMap((levels, levelsIndex) => {
    return levels.reduce((acc, user) => {
      if (user.id === currentUserID && levelsIndex === pendingIndex) {
        acc.push({ id: approvalRequest.id, level_position: levelsIndex + 1 });
      }
      return acc;
    }, []);
  });
};
